import React, { useRef, useState } from 'react'
import { string, bool, func } from 'prop-types'
import { Typography, Button, Stack } from '@mui/material'
import { addToDataLayer_nextgen } from '@helpers/google-tag-manager'
import { useSelector } from 'react-redux'
import ShippingChangeZip from './shipping-change-zip'

const BUTTON_ID = 'header-shop-deliver-menu-btn'
const MENU_ID = 'header-shop-deliver-menu'

const ShopAndDeliverTo = ({
  variant,
  bottom = true,
  initialShippingAddress = '',
  disablePreviousText = false,
  className,
  cbFunction,
  defaultOpened = false,
}) => {
  const anchorRef = useRef(null)
  const [open, setOpen] = useState(defaultOpened)
  const shippingAddress = useSelector(s => s?.location?.shipping_address)

  const onClickOpen = e => {
    e.preventDefault()
    addToDataLayer_nextgen('your_store_widget', {
      stores_action: 'delivery to',
    })
    setOpen(true)
  }

  const onClose = () => setOpen(false)

  const buttonAddress = typeof window === 'undefined' ? initialShippingAddress : shippingAddress

  const buttonAriaProps = {
    'aria-haspopup': 'true',
    'aria-label': `Change Shop and Deliver to location - ${buttonAddress}`,
    ...(open
      ? {
          'aria-controls': MENU_ID,
          'aria-expanded': 'true',
        }
      : {}),
  }

  const variantTitle = variant === 'plp' ? 'for' : 'Deliver to:'

  return (
    <>
      <Stack
        className={className}
        direction="row"
        spacing={0}
        alignItems="center"
        mb={bottom ? 3 : 0}
        sx={{ overflow: 'hidden', fontWeight: 600, maxHeight: 18 }}
      >
        {!disablePreviousText && (
          <Typography sx={{ fontSize: 16 }} aria-label={variantTitle}>
            {variantTitle}
          </Typography>
        )}
        <Button
          variant="text"
          size="medium"
          id={BUTTON_ID}
          ref={anchorRef}
          data-testid="changeShopDeliverToLocation"
          onClick={onClickOpen}
          sx={{
            minHeight: 36,
            whiteSpace: 'nowrap',
            ...(defaultOpened && { pointerEvents: 'none' }),
          }}
          title={buttonAddress}
          {...buttonAriaProps}
        >
          <Typography
            color={open ? '#333333' : 'primary'}
            sx={{
              textTransform: 'capitalize',
              textDecoration: open ? 'none' : 'underline',
              fontWeight: open ? 600 : 400,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {typeof window === 'undefined' ? initialShippingAddress : shippingAddress}
          </Typography>
        </Button>
      </Stack>
      <ShippingChangeZip
        variant={variant}
        anchorRef={anchorRef}
        className="header"
        open={open}
        onClose={onClose}
        cbFunction={cbFunction}
      />
    </>
  )
}

ShopAndDeliverTo.propTypes = {
  variant: string,
  bottom: bool,
  initialShippingAddress: string,
  disablePreviousText: bool,
  className: string,
  cbFunction: func,
  defaultOpened: bool,
}

export default ShopAndDeliverTo
